<template>
	<DialogControl v-model="open" max-width="560">
		<v-card rounded="xl" class="nav-dialog">
			<v-card-title class="nav-dialog__title">
				<v-icon color="primary">draft_orders</v-icon>
				<span>{{ t('DraftCartTitle') }}</span>
				<v-spacer />
				<v-btn icon variant="text" size="small" :aria-label="t('Close')" @click="open = false">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-progress-linear v-if="loading" indeterminate color="primary" />
				<v-list v-else-if="drafts.length" bg-color="transparent">
					<v-list-item v-for="draft in drafts" :key="draft.id" link class="nav-panel__item" @click="load(draft)">
						<template #prepend>
							<v-avatar color="primary" variant="tonal" size="36">
								<v-icon size="20">shopping_cart</v-icon>
							</v-avatar>
						</template>
						<v-list-item-title class="nav-panel__item-title">{{ draft.title }}</v-list-item-title>
						<div class="nav-panel__item-meta">{{ t('Date') }} : {{ formatDate(draft.modifiedDate) }} - {{ t('DraftNbProducts') }} : {{ draft.nbPdts }}</div>
						<template #append>
							<v-btn icon variant="text" size="small" color="error" :aria-label="t('DeleteDraftConfirmation')" @click.stop="askDelete(draft)">
								<v-icon>delete</v-icon>
							</v-btn>
						</template>
					</v-list-item>
				</v-list>
				<p v-else class="nav-dialog__text">{{ t('NoData') }}</p>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn variant="text" @click="open = false">{{ t('Close') }}</v-btn>
			</v-card-actions>
		</v-card>
	</DialogControl>

	<NavConfirmDialog v-model="confirmDelete" icon="delete" :title="t('DeleteDraftConfirmation')" :lines="[t('DeleteDraftConfirmationMsg')]" :confirm-text="t('Yes')" :cancel-text="t('Cancel')" @confirm="remove" />
</template>

<script setup>
import { ref, watch } from 'vue';
import DialogControl from '@/components/controls/DialogControl.vue';
import NavConfirmDialog from './NavConfirmDialog.vue';
import { legacyNav } from '@/iframe/legacyNavState';
import { loadDraftCart, readDraftCarts, refreshDraftCounter, removeDraftCart } from '@/iframe/legacyNavActions';
import { useTranslator } from '@/composables/useTranslator';

const open = defineModel({ type: Boolean, default: false });
const t = useTranslator();

const drafts = ref([]);
const loading = ref(false);
const confirmDelete = ref(false);
const pending = ref(null);

const formatDate = (value) => (value ? new Date(value).toLocaleString(legacyNav.user.locale || undefined) : '');

watch(open, async (value) => {
	if (!value) {
		refreshDraftCounter();
		return;
	}
	loading.value = true;
	drafts.value = await readDraftCarts();
	loading.value = false;
});

const load = (draft) => {
	open.value = false;
	loadDraftCart(draft.id);
};

const askDelete = (draft) => {
	pending.value = draft;
	confirmDelete.value = true;
};

const remove = () => {
	if (!pending.value) return;
	removeDraftCart(pending.value.id);
	drafts.value = drafts.value.filter((draft) => draft.id !== pending.value.id);
	pending.value = null;
};
</script>
